<div class="login-popup" *ngIf="!_as.isOnMobilePlatform">
    <p-dialog [(visible)]="_as.isDisplayLogin" [modal]="true" 
    [minY]="70" [baseZIndex]="10000">
  
    <div class="auth-box">
        <div class="auth-form">
          <div class="mobile-form-part" *ngIf="selected_form==='login'">
            <h4>Sign in Afterbricks</h4>
            <form [formGroup]="loginForm" autocomplete="off" (keydown)="onEnterFrom($event)" (ngSubmit)="onLogin()">
           
              <input maxlength="10" class="form-control rsp-input w-100 text-center" type="tel" placeholder="Mobile"
                size="30" formControlName="mobile" onfocus="this.placeholder = ''" if="mobile"
                onblur="this.placeholder='Mobile'" numbersOnly required pInputText autocomplete="none|false|no"
                (keydown.space)="$event.preventDefault();" required>
              <div class="error-contm" *ngIf="submission">
                <div style="color:red" *ngIf="f['mobile'].errors?.['required']">Mobile number required </div>
                <div *ngIf="invalidMobile">Phone number must be at least 10 numbers </div>
              </div>
  
  
              <button class="btn login-btn" [ngClass]="{'cursor-loader':inline_loader}" [disabled]="inline_loader">
                Login
                <i class="fa fa-spinner fa-spin" *ngIf="inline_loader"></i>
              </button>
            </form>
          </div>
          <div class="otp-form-part" *ngIf="selected_form==='otp'">
            <h4>OTP Verification</h4>
            <form [formGroup]="verifyOTP" autocomplete="off">
              <div class="m-number-strip">
  
                <p>
                  Enter 6 digit code sent to your phone
                </p>
                <span>+91-{{this.otp_detail.mobile}} <button class="change-btn"
                    (click)="onChangeMobile()">Change</button></span>
              </div>
              <div class="otp-sec">
                <input class="otp-input" type="tel" maxlength="6" minlength="6" formControlName="otp"
                  (keyup)="keyUpEvent()" placeholder="OTP" numbersOnly>
              </div>
              <div class="error-contm mt-2" *ngIf="submitted && otpf['otp'].errors">
                <div style="color:red" *ngIf="submitted && otpf['otp'].errors?.['required']">OTP required </div>
                <div style="color:red" *ngIf="submitted && otpf['otp'].errors?.['minlength'] && !otpf['otp'].errors?.['required']">
                  Enter minimum 6 digit password </div>
              </div>
              <div class="error-contm" *ngIf="submitted && otpDoesMetch  && !otpf['otp'].errors">
                <div style="color:red">
                  OTP does not match </div>
              </div>
              <button class="btn login-btn" (click)="onSubmitOtp(verifyOTP.value)"
                [ngClass]="{'cursor-loader':inline_loader}" [disabled]="inline_loader">
                Submit
                <i class="fa fa-spinner fa-spin" *ngIf="inline_loader"></i>
              </button>
              <div class="re-send-otp-strip">
                <p class="timer" *ngIf="!isShowReSend && interval"> Resend Code (in {{interval}} secs)</p>
                <a class="otp-a-resend" *ngIf="isShowReSend || !interval" (click)="resendOtp()">Re-Send</a>
              </div>
            </form>
          </div>
        </div>
        <div class="other-auth-form" *ngIf="selected_form==='login'">
          <div class="social-login">
            <p>Or sign in with</p>
            
                 <asl-google-signin-button type='icon' size='large' shape="rectangular" theme="outline" text="signin_with" logo_alignment="left" (click)="socialSignIn('google')">
                </asl-google-signin-button>
          </div>
  
          <div class="term-msg">
            <span> By continuing, you agree to afterbricks</span>
            <a routerLink="./../terms-and-condition" target="_blank">Terms of service & Privacy policy</a>
          </div>
        </div>
        <!-- *ngIf="selected_form==='create-project'" -->
        <div class="create-project-container" *ngIf="selected_form==='create-project'" >
            <div>
                <h3>How many bedroom house you have?</h3>
                <p>Now create product collection for every room</p>
                <div class="form-group mb-0">
                  <!-- <label class="required-field mb-0" >Bedroom*</label> -->
                  <div class="ab-project-box">
                    <ul class="ab-project-ul mb-0">
                      <li *ngFor="let val of hometypes;let i=index">
                        <div class="hometype-card" (click)="setHomeType(val)"
                          [ngClass]="{'active-hometype-card':val.id===selectedHomeId}">
                          <span>{{val.name}}</span>
                        </div>
      
                      </li>
      
                    </ul>
                  </div>
                  <span *ngIf="is_project_error" class="err-text" style="position: absolute;">Select one option from the list</span>
                </div>
              </div>
              <div class="project-footer">
                <button class="btn login-btn" (click)="createProject()" [ngClass]="{'cursor-loader':isProjectCreateLoader}" [disabled]="isProjectCreateLoader">
                    <i class="fa fa-spinner fa-spin" *ngIf="isProjectCreateLoader"></i>
                    Continue
                </button>
              </div>
              <p class="note-text">Note: Products are available for commercial spaces as well, but collection can we made for houses right now.</p>
        </div>
      </div>
    </p-dialog>
    </div>
    <div class="new-login-slider" *ngIf="_as.isOnMobilePlatform">
    <p-sidebar [(visible)]="_as.isDisplayLogin" [modal]="true" (onHide)="hideLoginSlider()" position="bottom" [dismissible]="false" [blockScroll]="true" [baseZIndex]="10000">
        <div>
            <div class="auth-form">
              <div class="mobile-form-part" *ngIf="selected_form==='login'">
                <h4>Sign in Afterbricks</h4>
                <form [formGroup]="loginForm" autocomplete="off" (ngSubmit)="onLogin()">
                  <input maxlength="10" class="form-control rsp-input w-100 text-center" placeholder="Mobile" size="30"
                    formControlName="mobile" onfocus="this.placeholder = ''" type="tel" onblur="this.placeholder='Mobile'"
                    numbersOnly required pInputText autocomplete="none|false|no" (keydown.space)="$event.preventDefault();"
                    required>
                  <div class="error-contm" *ngIf="submission">
                    <div style="color:red" *ngIf="f['mobile'].errors?.['required']">Mobile number required </div>
                    <div *ngIf="invalidMobile">Phone number must be at least 10 numbers </div>
                  </div>
                  <button class="btn login-btn" [ngClass]="{'cursor-loader':inline_loader}" [disabled]="inline_loader">
                    <i class="fa fa-spinner fa-spin" *ngIf="inline_loader"></i>
                    Login
                  </button>
                </form>
              </div>
              <div class="otp-form-part" *ngIf="selected_form==='otp'">
                <h4>OTP Verification</h4>
                <form [formGroup]="verifyOTP" autocomplete="off">
                  <div class="m-number-strip">
                    <p>
                      Enter 6 digit code sent to your phone
                    </p>
                    <span>+91-{{this.otp_detail.mobile}} <button class="change-btn"
                        (click)="onChangeMobile()">Change</button></span>
                  </div>
                  <div class="otp-sec">
                    <input class="otp-input" type="tel" maxlength="6" minlength="6" formControlName="otp"
                      (keyup)="keyUpEvent()" placeholder="OTP" numbersOnly>
      
                  </div>
                  <div class="error-contm mt-2" *ngIf="submitted && otpf['otp'].errors">
                    <div style="color:red" *ngIf="submitted && otpf['otp'].errors?.['required']">OTP required </div>
                    <div style="color:red" *ngIf="submitted && otpf['otp'].errors?.['minlength'] && !otpf['otp'].errors?.['required']">
                      Enter minimum 6 digit password </div>
                  </div>
                  <div class="error-contm" *ngIf="submitted && otpDoesMetch  && !otpf['otp'].errors">
                    <div style="color:red">
                      OTP does not match </div>
                  </div>
                  <button class="btn login-btn" (click)="onSubmitOtp(verifyOTP.value)"
                    [ngClass]="{'cursor-loader':inline_loader}" [disabled]="inline_loader">
                    Submit
                  </button>
                  <div class="re-send-otp-strip">
                    <p class="timer" *ngIf="!isShowReSend && interval"> Resend Code (in {{interval}} secs)</p>
                    <a class="otp-a-resend" *ngIf="isShowReSend || !interval" (click)="resendOtp()">Re-Send</a>
                  </div>
                </form>
              </div>
            </div>
            <div class="other-auth-form" *ngIf="selected_form==='login'">
              <div class="social-login">
                <p style="margin-right: 10px;">Or sign in with</p>
                <!-- <a class="google-login" (click)="socialSignIn('google')" style="cursor: pointer;"
                  [ngClass]="{'disabled-soc':inline_loader}">
                  <img src="assets/images/google-48.png" alt="google">
                  <div class="s-loader" *ngIf="inline_loader">
                    <i class="fa fa-spinner fa-spin"></i>
                  </div>
      
                </a> -->
                <asl-google-signin-button type='icon' size='large' shape="rectangular" theme="outline" text="signin_with" logo_alignment="left"  (click)="socialSignIn('google')">
                </asl-google-signin-button>
              </div>
      
              <div class="term-msg">
                <span> By continuing, you agree to afterbricks</span>
                <a routerLink="./../terms-and-condition" target="_blank">Terms of service & Privacy policy</a>
              </div>
            </div>
            <div class="create-project-container" *ngIf="selected_form==='create-project'" >
                <div>
                    <h3>How many bedroom house you have? </h3>
                    <p>Now create product collection for every room</p>
                    <div class="form-group mb-0">
                      <div class="ab-project-box">
                        <ul class="ab-project-ul mb-0">
                          <li *ngFor="let val of hometypes;let i=index">
                            <div class="hometype-card" (click)="setHomeType(val)"
                              [ngClass]="{'active-hometype-card':val.id===selectedHomeId}">
                              <span>{{val.name}}</span>
                            </div>
          
                          </li>
          
                        </ul>
                      </div>
                      <span *ngIf="is_project_error" class="err-text" style="position: absolute;">Select one option from the list</span>
                    </div>
                  </div>
                  <div class="project-footer">
                    <button class="btn login-btn" (click)="createProject()" [ngClass]="{'cursor-loader':isProjectCreateLoader}" [disabled]="isProjectCreateLoader">
                        <i class="fa fa-spinner fa-spin" *ngIf="isProjectCreateLoader"></i>
                        Continue
                    </button>
                  </div>
                  <p class="note-text">Note: Products are available for commercial spaces as well, but collection can we made for houses right now.</p>
            </div>
          </div>
    </p-sidebar>
  </div>